import {Edit} from 'react-admin';

const EditMod = props => {
    return (<Edit {...props} ></Edit>);
};

export default EditMod;